<template>
  <div class="columns is-gapless is-multiline">
    <div class="column is-full">
      <b-checkbox size="is-small" @input="selectSeries($event, item.seriesId)" :value="isRowSelected(item.seriesId)">
        {{ item.name }}
      </b-checkbox>
    </div>

    <div class="column" :class="columnWidth(row)" v-for="(row, index) of currentChilds(item.seriesId)" :key="index">
      <TableSeriesLevel
        :item="row"
        :rows="currentChilds(row.seriesId)"
        :selectedSeries="selectedSeries"
        @selectSeries="selectChild"
      ></TableSeriesLevel>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    TableSeriesLevel: () => import(/* webpackChunkName: "TableSeriesLevel" */ '@/components/table/TableSeriesLevel')
  },
  props: {
    rows: {
      type: Array,
      default: () => []
    },

    selectedSeries: {
      type: Array,
      default: () => []
    },

    item: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    selectChild(data) {
      const { status, id } = data;
      this.selectSeries(status, id);
    },

    selectSeries(status, id) {
      this.$emit('selectSeries', { status, id });
    },

    isRowSelected(id) {
      if (this.selectedSeries.some(el => el === id)) {
        return false;
      } else return true;
    },

    currentChilds(id) {
      return this.rows.filter(el => el.parent === id);
    },

    columnWidth(row) {
      const childs = this.currentChilds(row.id);
      return childs.length > 0 ? 'is-one-quarter' : 'is-full';
    }
  }
};
</script>

<style lang="scss" scoped></style>
